/* Raindoor DS v1.0 — Páginas de contenido: revelado, acordeones, centro de ayuda, galerías, compartir. */
(function () {
  if (window.__rdPages) return;
  window.__rdPages = true;

  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }

  /* Revelado al hacer scroll */
  function initReveal(root) {
    var els = $$('.rp-reveal:not(.is-in)', root);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Acordeones */
  function toggle(item, open) {
    var btn = item.querySelector('.rp-acc__q');
    var isOpen = typeof open === 'boolean' ? open : !item.classList.contains('is-open');
    item.classList.toggle('is-open', isOpen);
    if (btn) btn.setAttribute('aria-expanded', String(isOpen));
  }

  /* Centro de ayuda: pestañas, navegación de temas y buscador */
  function initHelp(root) {
    var tabs = $$('[data-rp-tab]', root);
    var panels = $$('[data-rp-panel]', root);
    function show(name) {
      tabs.forEach(function (t) { var on = t.dataset.rpTab === name; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });
      panels.forEach(function (p) { p.hidden = p.dataset.rpPanel !== name; });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.rpTab); }); });
    if (location.hash) {
      var target = root.querySelector(location.hash.replace(/[^#\w-]/g, ''));
      var panel = target && target.closest('[data-rp-panel]');
      if (panel) show(panel.dataset.rpPanel);
    }

    var input = root.querySelector('[data-rp-search]');
    var empty = root.querySelector('[data-rp-empty]');
    if (input) {
      var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
      input.addEventListener('input', function () {
        var q = norm(input.value.trim());
        var hits = 0;
        if (q) show('faq');
        $$('[data-rp-panel="faq"] .rp-help__group', root).forEach(function (g) {
          var any = false;
          $$('.rp-acc__item', g).forEach(function (it) {
            var ok = !q || norm(it.textContent).indexOf(q) > -1;
            it.hidden = !ok;
            toggle(it, !!q && ok);
            if (ok) { any = true; hits++; }
          });
          g.hidden = !any;
        });
        if (empty) empty.hidden = !q || hits > 0;
      });
    }

    var links = $$('.rp-help__nav a', root);
    if ('IntersectionObserver' in window && links.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + en.target.id); });
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      $$('.rp-help__group', root).forEach(function (g) { io.observe(g); });
    }
  }

  /* Galerías del artículo */
  function initGallery(gal) {
    var track = gal.querySelector('.rp-gal__track');
    var count = gal.querySelector('[data-rp-count]');
    var slides = $$('.rp-gal__slide', gal);
    if (!track || !slides.length) return;
    function current() {
      var x = track.scrollLeft;
      var i = 0;
      slides.forEach(function (s, idx) { if (s.offsetLeft - track.offsetLeft <= x + 10) i = idx; });
      return i;
    }
    function update() { if (count) count.textContent = String(current() + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0'); }
    $$('[data-rp-dir]', gal).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = Math.max(0, Math.min(slides.length - 1, current() + Number(b.dataset.rpDir)));
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* Blog: "Cargar más" trae la página siguiente (Section Rendering API) y la agrega a la grilla:
     su artículo grande a todo el ancho y luego sus tarjetas, así cada tanda cierra en filas completas. */
  function loadMorePosts(btn) {
    var box = btn.closest('[data-rp-more]');
    var next = box && box.dataset.next;
    var grid = document.querySelector('.rp-blog__grid');
    if (!next || !grid) return;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Cargando…';
    fetch(next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(box.dataset.sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var feat = doc.querySelector('.rp-feat');
        if (feat) grid.appendChild(feat);
        $$('.rp-blog__grid > .rp-post', doc).forEach(function (p) { grid.appendChild(p); });
        $$('.rp-reveal', grid).forEach(function (e) { e.classList.add('is-in'); });
        var nb = doc.querySelector('[data-rp-more]');
        var total = Number(box.dataset.total) || 0;
        var shown = $$('.rp-post, .rp-feat', document.querySelector('.rp-blog')).length;
        if (total) shown = Math.min(shown, total);
        var shownEl = box.querySelector('[data-rp-shown]');
        if (shownEl) shownEl.textContent = shown;
        var fill = box.querySelector('.rd-plp-more__fill');
        if (fill && total) fill.style.width = Math.min(100, Math.round(shown / total * 100)) + '%';
        var nextPages = nb && nb.querySelector('.rd-plp-pages');
        var pages = box.querySelector('.rd-plp-pages');
        if (nextPages && pages) pages.innerHTML = nextPages.innerHTML;
        box.dataset.next = nb ? (nb.dataset.next || '') : '';
        if (!box.dataset.next) btn.remove();
        else { btn.disabled = false; btn.textContent = label; }
      })
      .catch(function () { window.location.href = next; });
  }

  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-rp-load-more]');
    if (more) { loadMorePosts(more); return; }
    var q = e.target.closest('.rp-acc__q');
    if (q) { toggle(q.closest('.rp-acc__item')); return; }
    var copy = e.target.closest('[data-rp-copy]');
    if (copy) {
      var url = copy.dataset.rpCopy || location.href;
      var done = function () { var t = copy.textContent; copy.textContent = 'Enlace copiado'; setTimeout(function () { copy.textContent = t; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
    }
  });

  function init(root) {
    root = root || document;
    initReveal(root);
    $$('[data-rp-help]', root).forEach(initHelp);
    $$('.rp-gal', root).forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
